import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import Typography from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'
import { Project } from 'Models/project'
import React, { useState } from 'react'
import ManageProjectTeamPopup from './ManageProjectTeamPopup'

interface IdNameProps {
    id: string
    name: string
    roles: string[]
}
interface ProjectTeamProps {
    projectData: Partial<Project> | undefined
    variant?: 'readOnly' | 'full'
    professionalDisciplines?: Partial<IdNameProps>[]
}
const ProjectTeamMembers: React.FC<ProjectTeamProps> = ({
    projectData,
    variant,
    professionalDisciplines,
}) => {
    const theme = useTheme()
    const [dialogOpen, setDialogOpen] = useState<boolean>(false)

    const handleDialogClose = () => {
        setDialogOpen(false)
    }
    const handleDialogOpen = () => {
        setDialogOpen(true)
    }
    return (
        <>
            <RoundButton
                size="large"
                hasShadow={false}
                color={theme.palette.secondary.main}
                borderColor={theme.palette.secondary.main}
                hoverColor="#A58968"
                backgroundColor="#fff"
                data-testid="btnAddTeamMember"
                onClick={handleDialogOpen}
                disabled={variant !== 'full'}
            >
                <Typography component="span">Add Team Member</Typography>
            </RoundButton>

            {dialogOpen && (
                <ManageProjectTeamPopup
                    projectId={projectData?.id!}
                    open={dialogOpen}
                    handleDialogClose={handleDialogClose}
                    variant="add"
                />
            )}
        </>
    )
}
export default ProjectTeamMembers
